import script from "./SettingsConfigurationView.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsConfigurationView.vue?vue&type=script&setup=true&lang=js"

import "./SettingsConfigurationView.vue?vue&type=style&index=0&id=de1206ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de1206ca"]])

export default __exports__